import { AxiosInstance } from 'axios';
import {
  EventOrdersEnum,
  Params,
  OrdersParser,
  Payload,
  OrderParser,
} from './types';
import { parseEventOrders, parseEventOrder } from './utils';

export const getEventOrdersData = (api: AxiosInstance) => ({
  getEventOrders: async (
    params: Params,
    parseData: OrdersParser = parseEventOrders,
  ): Promise<any> => {
    const { data } = await api.get<any>(EventOrdersEnum.GET_EVENT_ORDERS, {
      params,
    });
    return { ...data, data: parseData(data.data) };
  },
});

export const getEventOrderData = (api: AxiosInstance) => ({
  getEventOrder: async (
    id: string,
    parseData: OrderParser = parseEventOrder,
  ): Promise<any> => {
    const { data } = await api.get<any>(
      `${EventOrdersEnum.GET_EVENT_ORDER}/${id}`,
    );
    return { ...data, data: parseData(data.data) };
  },
});

export const postEventOrderCreateData = (api: AxiosInstance) => ({
  postEventOrderCreate: async (payload: any): Promise<any> => {
    const result = await api.post(EventOrdersEnum.POST_CREATE_EVENT_ORDER, {
      data: payload,
    });
    return result;
  },
});

export const postCancelEventOrderData = (api: AxiosInstance) => ({
  postCancelEventOrder: async (id: string | number) => {
    const result = await api.post(
      `${EventOrdersEnum.POST_CANCEL_EVENT_ORDERS}/${id}`,
    );
    return result;
  },
});

export const eventOrdersService = (api: AxiosInstance) => {
  if (!api) throw new Error('There is no HTTP client');
  return {
    ...getEventOrdersData(api),
    ...getEventOrderData(api),
    ...postCancelEventOrderData(api),
    ...postEventOrderCreateData(api),
  };
};



// WEBPACK FOOTER //
// ./src/services/api/event-orders/eventOrdersService.ts